"use strict";

var _objectSpread = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/objectSpread2.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = renderChildren;
var _react = _interopRequireDefault(require("react"));
var _TNodeRenderer = _interopRequireDefault(require("./TNodeRenderer"));
var _collapseTopMarginForChild = _interopRequireDefault(require("./helpers/collapseTopMarginForChild"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var empty = {};
var mapCollapsibleChildren = function mapCollapsibleChildren(propsForChildren, renderChild, disableMarginCollapsing, childTnode, n, tchildren) {
  var collapsedMarginTop = disableMarginCollapsing ? null : (0, _collapseTopMarginForChild.default)(n, tchildren);
  var propsFromParent = _objectSpread(_objectSpread({}, propsForChildren), {}, {
    collapsedMarginTop: collapsedMarginTop
  });
  var key = childTnode.nodeIndex;
  var childElement = /*#__PURE__*/_react.default.createElement(_TNodeRenderer.default, {
    propsFromParent: propsFromParent,
    tnode: childTnode,
    key: key,
    renderIndex: n,
    renderLength: tchildren.length
  });
  return typeof renderChild === 'function' ? renderChild({
    key: key,
    childElement: childElement,
    index: n,
    childTnode: childTnode,
    propsFromParent: propsFromParent
  }) : childElement;
};
function renderChildren(_ref) {
  var tchildren = _ref.tchildren,
    _ref$propsForChildren = _ref.propsForChildren,
    propsForChildren = _ref$propsForChildren === void 0 ? empty : _ref$propsForChildren,
    disableMarginCollapsing = _ref.disableMarginCollapsing,
    renderChild = _ref.renderChild;
  var elements = tchildren.map(mapCollapsibleChildren.bind(null, propsForChildren, renderChild, disableMarginCollapsing));
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, elements);
}